import { MapPin, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
export default function Hero() {
  return <section id="hero" data-nav="dark" className="dark relative min-h-[85vh] lg:min-h-[90vh] flex items-center bg-background text-foreground overflow-hidden">
      {/* Background clinical/movement imagery with atmospheric scrims */}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1754222/img/physio_movement_batchwood_stalbans.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1754222/img/physio_movement_batchwood_stalbans.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1754222/img/physio_movement_batchwood_stalbans.png-wvc-sizes" alt="Physiotherapy and biomechanics session at Batchwood" className="h-full w-full object-cover object-center opacity-40 scale-100" loading="eager" />
        {/* Deep slate / navy gradient overlay for guaranteed text legibility */}
        <div className="absolute inset-0 bg-linear-to-r from-slate-950/95 via-slate-950/80 to-slate-900/60" />
        <div className="absolute inset-0 bg-linear-to-t from-slate-950 via-transparent to-slate-950/50" />
      </div>

      {/* Decorative ambient subtle glow */}
      <div aria-hidden="true" className="pointer-events-none absolute -top-24 left-1/4 h-96 w-96 rounded-full bg-primary/20 blur-3xl" />

      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="max-w-3xl">
          {/* Eyebrow */}
          <div className="mb-6 inline-flex">
            <Badge variant="secondary" className="px-3.5 py-1 text-xs sm:text-sm font-medium tracking-wide uppercase bg-secondary/80 text-secondary-foreground border border-border/40 backdrop-blur-xs">
              PhysAnalytica St Albans
            </Badge>
          </div>

          {/* Main H1 Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-[1.1] mb-6">
            Physiotherapy and biomechanics at Batchwood, St Albans
          </h1>

          {/* Supporting description paragraphs */}
          <p className="text-lg sm:text-xl text-slate-300 leading-relaxed mb-4 max-w-2xl font-normal">
            PhysAnalytica provides expert physiotherapy and specialist biomechanics from Batchwood Golf and Sports Centre in St Albans, helping people understand pain, movement and loading so they can move with greater confidence.
          </p>

          <p className="text-base sm:text-lg text-slate-400 leading-relaxed mb-8 max-w-2xl font-normal">
            Clinical expertise comes first, supported by objective biomechanics technology where it adds useful information to assessment and treatment.
          </p>

          {/* Action CTAs */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 mb-10">
            <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground font-medium px-7 shadow-md group transition-all">
              <Link to="https://physiogenics.uk3.cliniko.com/bookings?business_id=1933385715966552600" newTab>
                Book Batchwood
                <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" />
              </Link>
            </Button>

            <Button asChild size="lg" variant="outline" className="border-slate-700 bg-slate-900/60 text-slate-100 hover:bg-slate-800/80 hover:text-white backdrop-blur-xs">
              <Link to="#services-batchwood">
                Choose a Service
              </Link>
            </Button>
          </div>

          {/* Clinic trust line: Location */}
          <div className="pt-6 border-t border-slate-800/80 max-w-xl">
            <div className="flex flex-wrap items-center gap-y-2 text-xs sm:text-sm text-slate-300 font-medium">
              <span className="inline-flex items-center gap-1.5">
                <MapPin className="size-4 text-primary shrink-0" />
                Batchwood Golf and Sports Centre, AL3 5XA
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}